module.exports = __webpack_public_path__ + "6cff793f57943643c43e987b270c97c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-4/mk.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-4/mk.jpg
// module chunks = 40